import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from '@/components/ui/command';
import { CaretDown } from '@phosphor-icons/react';
import { COUNTRIES, flagEmoji } from '@/lib/countries';

// Seletor de indicativo telefónico com pesquisa (todos os países). Valor = dial code (ex: "+351").
export function CountryCodeSelect({ value = '+351', onChange, className = '', testId = 'country-code-select' }) {
  const [open, setOpen] = useState(false);
  const sel = COUNTRIES.find(c => c.d === value) || COUNTRIES.find(c => c.c === 'PT');
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`flex items-center gap-1 border border-brand-border rounded-xl px-2 py-2 text-xs bg-white ${className}`} data-testid={testId}>
          <span>{flagEmoji(sel?.c)}</span>
          <span>{value}</span>
          <CaretDown size={12} className="text-brand-muted" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-64" align="start">
        <Command>
          <CommandInput placeholder="Procurar país..." data-testid="country-search" />
          <CommandList className="max-h-64">
            <CommandEmpty>Sem resultados.</CommandEmpty>
            {COUNTRIES.map(c => (
              <CommandItem
                key={c.c}
                value={`${c.n} ${c.d} ${c.c}`}
                onSelect={() => { onChange(c.d); setOpen(false); }}
                data-testid={`country-option-${c.c}`}
              >
                <span className="mr-2">{flagEmoji(c.c)}</span>
                <span className="flex-1 truncate text-sm">{c.n}</span>
                <span className="text-xs text-brand-muted ml-2">{c.d}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default CountryCodeSelect;
